import { Accordion } from '@unistocks/components/accordion/accordion';
import { getLocation, Table } from '@unistocks/components/table/table';
import { isNumber } from '@unistocks/shared/utils/util';
import { ReactNode } from 'react';
import { Separator, View } from 'tamagui';

export type ValueListTableProps<T> = {
  firstList: T[];
  secondList?: T[];
  visibleItemsLimit?: number;
  renderRow: (value: T, index: number) => ReactNode;
  getRowOnPress?: (value: T, index: number) => (() => void) | undefined;
};

type RenderTableRow<T> = (value: T, i: number, arr: T[]) => ReactNode;

export function ValueListTable<T>({
  firstList,
  secondList,
  visibleItemsLimit,
  renderRow,
  getRowOnPress
}: ValueListTableProps<T>) {
  const renderTableRow: RenderTableRow<T> = (value, i, arr) => {
    const onPress = getRowOnPress?.(value, i);

    return (
      <Table.Row
        key={i}
        rowLocation={getLocation(i, arr)}
        pressable={!!onPress}
        hoverable={!!onPress}
        onPress={onPress}
        className={onPress ? 'prevent-drag' : undefined}
      >
        {renderRow(value, i)}
      </Table.Row>
    );
  };

  let firstListVisible = firstList,
    firstListHidden: T[] = [],
    secondListVisible = secondList,
    secondListHidden: T[] = [];

  if (isNumber(visibleItemsLimit) && visibleItemsLimit > 0) {
    firstListVisible = firstList.slice(0, visibleItemsLimit);
    firstListHidden = firstList.slice(visibleItemsLimit);
    if (secondList?.length) {
      secondListVisible = secondList?.slice(0, visibleItemsLimit);
      secondListHidden = secondList?.slice(visibleItemsLimit);
    }
  }
  return (
    <Table cellHeight={'$3.5'}>
      <Table.Body>
        {firstListVisible.map(renderTableRow)}
        {firstListHidden.length > 0 ? (
          <Accordion type="single" collapsible>
            <Accordion.Item value="more">
              <Accordion.Content>
                <Separator my={'$1'} />
                {firstListHidden.map(renderTableRow)}
              </Accordion.Content>
              <Accordion.IconTrigger />
            </Accordion.Item>
          </Accordion>
        ) : null}

        {secondListVisible?.length ? (
          <>
            {!firstListHidden.length ? <View my={'$2'} /> : null}
            {secondListVisible.map(renderTableRow)}
            {secondListHidden && secondListHidden.length > 0 ? (
              <Accordion type="single" collapsible>
                <Accordion.Item value="more">
                  <Accordion.Content>
                    <Separator my={'$1'} />
                    {secondListHidden.map(renderTableRow)}
                  </Accordion.Content>
                  <Accordion.IconTrigger />
                </Accordion.Item>
              </Accordion>
            ) : null}
          </>
        ) : null}
      </Table.Body>
    </Table>
  );
}

ValueListTable.displayName = 'ValueListTable';
